import React from 'react';

import Typeahead from '../Typeahead/Typeahead';

import { getCompanyId, getCompanyName } from './helpers';

export const CREATE_API = '/api/company/create';
export const TYPEAHEAD_API = '/api/company/typeahead';

const CompanySelectorInput = ({
    items,
    isMulti,
    withTags,
    inputId,
    allowAPICreation,
    setTypeaheadInput,
    handleError,
    handleSelect,
    placeholder,
    className,
}) => {
    const formatCompanyResult = (company) => {
        const companyId = getCompanyId(company);
        const companyName = getCompanyName(company);
        return {
            companyId,
            companyName,
            id: companyId,
            name: companyName,
            option: companyName,
            logo: company.logo,
        };
    };

    const selectedSuggestions = items.map((c) => formatCompanyResult(c));

    return (
        <div>
            <Typeahead
                allowAddNewItem={true}
                createNewItemApi={allowAPICreation && CREATE_API}
                fetchSuggestionsApi={TYPEAHEAD_API}
                isMulti={isMulti}
                onChange={setTypeaheadInput}
                onError={handleError}
                onSelect={handleSelect}
                placeholderText={placeholder}
                selectedSuggestions={selectedSuggestions}
                setUserInput={formatCompanyResult}
                cssClass={className}
                withTags={withTags}
                qaDataAttr="company"
                inputId={inputId}
            />
        </div>
    );
};
export default CompanySelectorInput;
